import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, Plus, Mail, Phone, Building2, MoreVertical, CheckCircle2, X, MapPin, ChevronRight } from 'lucide-react';
import { MobileLayout } from '../../components/MobileLayout';
import { useScreenInit } from '../../useScreenInit.js';
import { REFERENTI, TYPE_STYLE } from './referentiData';
export function CmReferentiPage() {
  useScreenInit();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [isAddOpen, setIsAddOpen] = useState(false);
  const filtered = REFERENTI.filter(r => {
    const full = `${r.firstName} ${r.lastName}`.toLowerCase();
    const q = query.toLowerCase();
    return full.includes(q) || r.email.toLowerCase().includes(q) || r.zone.toLowerCase().includes(q);
  });
  return <MobileLayout data-id="element-2339">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-id="element-2340">
        <div data-id="element-2341">
          <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2342">Referenti</h1>
        </div>
        <button onClick={() => setIsAddOpen(true)} className="w-full sm:w-auto px-4 py-2.5 bg-coral text-white rounded-xl hover:bg-coral-600 transition-colors text-sm font-medium min-h-[44px] flex items-center justify-center gap-2" data-id="element-2343">
          <Plus size={18} data-id="element-2344" />
          Aggiungi referente
        </button>
      </div>

      {/* Sub-nav between Referenti / Appartamenti */}
      <div className="inline-flex items-center gap-1 bg-gray-100 rounded-lg p-1 mb-6" data-id="element-2345">
        <span className="px-3 py-1.5 rounded-md text-sm font-medium bg-white text-navy shadow-sm" data-id="element-2346">
          Referenti
        </span>
        <Link to="/cm/clienti/appartamenti" className="px-3 py-1.5 rounded-md text-sm font-medium text-gray-500 hover:text-navy transition-colors" data-id="element-2347">
          Appartamenti
        </Link>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-xl border border-border shadow-sm mb-6" data-id="element-2348">
        <div className="relative" data-id="element-2349">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-2350" />
          <input type="text" placeholder="Cerca per nome, email o zona..." value={query} onChange={e => setQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none transition-all min-h-[44px]" data-id="element-2351" />
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden" data-id="element-2352">
        <div className="overflow-x-auto" data-id="element-2353">
          <table className="w-full text-left border-collapse min-w-[760px]" data-id="element-2354">
            <thead data-id="element-2355">
              <tr className="bg-gray-50 border-b border-border" data-id="element-2356">
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2357">
                  Referente
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2358">
                  Tipologia
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2359">
                  Contatti
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2360">
                  Appartamenti
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2361">
                  Contratto
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-2362">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-2363">
              {filtered.map(r => <tr key={r.id} onClick={() => navigate(`/cm/clienti/referenti/${r.id}`)} className="hover:bg-gray-50/50 transition-colors cursor-pointer" data-id="element-2364">
                  <td className="px-4 lg:px-6 py-4" data-id="element-2365">
                    <div className="flex items-center gap-3" data-id="element-2366">
                      <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-navy font-bold flex-shrink-0 text-sm" data-id="element-2367">
                        {r.firstName[0]}
                        {r.lastName[0]}
                      </div>
                      <div className="min-w-0" data-id="element-2368">
                        <div className="text-sm font-semibold text-navy whitespace-nowrap" data-id="element-2369">
                          {r.firstName} {r.lastName}
                        </div>
                        <div className="flex items-center gap-1 text-xs text-gray-500 whitespace-nowrap" data-id="element-2370">
                          <MapPin size={11} className="text-gray-400" data-id="element-2371" />
                          {r.zone}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2372">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border whitespace-nowrap ${TYPE_STYLE[r.type]}`} data-id="element-2373">
                      {r.type}
                    </span>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2374">
                    <div className="space-y-1" data-id="element-2375">
                      <div className="flex items-center gap-2 text-sm text-gray-600 whitespace-nowrap" data-id="element-2376">
                        <Mail size={14} className="text-gray-400" data-id="element-2377" />
                        {r.email}
                      </div>
                      <div className="flex items-center gap-2 text-sm text-gray-600 whitespace-nowrap" data-id="element-2378">
                        <Phone size={14} className="text-gray-400" data-id="element-2379" />
                        {r.phone}
                      </div>
                    </div>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2380">
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-navy whitespace-nowrap" data-id="element-2381">
                      <Building2 size={14} className="text-gray-400" data-id="element-2382" />
                      {r.apartments}
                    </span>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2383">
                    {r.activeContract ? <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-200 whitespace-nowrap" data-id="element-2384">
                        <CheckCircle2 size={13} data-id="element-2385" />
                        Attivo
                      </span> : <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500 border border-gray-200 whitespace-nowrap" data-id="element-2386">
                        Nessuno
                      </span>}
                  </td>
                  <td className="px-4 lg:px-6 py-4 text-right" data-id="element-2387">
                    <div className="flex items-center justify-end gap-1" data-id="element-2388">
                      <button onClick={e => e.stopPropagation()} aria-label="Azioni referente" className="p-2 text-gray-400 hover:text-navy rounded-lg hover:bg-gray-100 transition-colors" data-id="element-2389">
                        <MoreVertical size={18} data-id="element-2390" />
                      </button>
                      <ChevronRight size={18} className="text-gray-300 flex-shrink-0" data-id="element-2391" />
                    </div>
                  </td>
                </tr>)}
              {filtered.length === 0 && <tr data-id="element-2392">
                  <td colSpan={6} className="px-6 py-10 text-center text-sm text-gray-500" data-id="element-2393">
                    Nessun referente trovato.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Referente Modal */}
      {isAddOpen && <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setIsAddOpen(false)} data-id="element-2394">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Nuovo referente" data-id="element-2395">
            <div className="flex items-center justify-between p-4 border-b border-border" data-id="element-2396">
              <h2 className="text-lg font-bold text-navy" data-id="element-2397">Nuovo referente</h2>
              <button onClick={() => setIsAddOpen(false)} aria-label="Chiudi" className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-2398">
                <X size={20} className="text-gray-500" data-id="element-2399" />
              </button>
            </div>
            <div className="p-4 overflow-y-auto space-y-4" data-id="element-2400">
              <div className="grid grid-cols-2 gap-4" data-id="element-2401">
                <div data-id="element-2402">
                  <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2403">
                    Nome
                  </label>
                  <input type="text" placeholder="Mario" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-2404" />
                </div>
                <div data-id="element-2405">
                  <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2406">
                    Cognome
                  </label>
                  <input type="text" placeholder="Rossi" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-2407" />
                </div>
              </div>
              <div data-id="element-2408">
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2409">
                  Tipologia
                </label>
                <select className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none bg-white min-h-[44px]" data-id="element-2410">
                  <option data-id="element-2411">Host</option>
                  <option data-id="element-2412">Property Manager</option>
                  <option data-id="element-2413">B&B</option>
                  <option data-id="element-2414">Agenzia</option>
                </select>
              </div>
              <div data-id="element-2415">
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2416">
                  Email
                </label>
                <input type="email" placeholder="mario.rossi@example.com" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-2417" />
              </div>
              <div data-id="element-2418">
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-2419">
                  Telefono
                </label>
                <input type="tel" placeholder="+39 333 1234567" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-2420" />
              </div>
            </div>
            <div className="p-4 border-t border-border bg-gray-50 flex justify-end gap-3" data-id="element-2421">
              <button onClick={() => setIsAddOpen(false)} className="px-4 py-2.5 bg-white border border-border text-gray-700 rounded-full hover:bg-gray-50 transition-colors text-sm font-medium min-h-[44px]" data-id="element-2422">
                Annulla
              </button>
              <button onClick={() => setIsAddOpen(false)} className="px-6 py-2.5 bg-coral text-white rounded-xl hover:bg-coral-600 transition-colors text-sm font-medium min-h-[44px]" data-id="element-2423">
                Salva referente
              </button>
            </div>
          </div>
        </div>}
    </MobileLayout>;
}